// extracted by mini-css-extract-plugin
module.exports = {"CreditCardInfoIcon":"Icon_CreditCardInfoIcon__2QrtZ","IconStroke":"Icon_IconStroke__1BNVN"};